// extracted by mini-css-extract-plugin
module.exports = {"tasks":"Tasks_tasks__1Rh5K","buttons":"Tasks_buttons__1P-HW","tasksWrapper":"Tasks_tasksWrapper__3UWnL","table":"Tasks_table__1PxxL"};